import * as React from 'react';
import { Select, Checkbox } from '../../../../components';
import { Option } from '../../types';

interface OptionRowProps {
  option: Option;
  isSelected: boolean;
  onToggle(option: Option);
}

export class OptionRow extends React.PureComponent<OptionRowProps, {}> {
  handleSelect = () => {
    this.props.onToggle(this.props.option);
  };

  render() {
    return (
      <Select.Row onClick={this.handleSelect}>
        <Checkbox isChecked={this.props.isSelected} />
        <span className='ms-1'>{this.props.option.name}</span>
      </Select.Row>
    );
  }
}
